__turbopack_context__.v({
  "navButton": "ImageCarousel-module-scss-module__KgN-JW__navButton",
  "navButtonLeft": "ImageCarousel-module-scss-module__KgN-JW__navButtonLeft",
  "navButtonRight": "ImageCarousel-module-scss-module__KgN-JW__navButtonRight",
});
